import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormLabel,
  Box,
} from '@chakra-ui/react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';

import 'react-datepicker/dist/react-datepicker.css';

interface IDatePickerProps extends ChakraInputProps {
  excludeDates?: Date[];
  hideTodayButton?: boolean;
  includeDates?: Date[];
  isClearable?: boolean;
  label?: string;
  maxDate?: Date;
  minDate?: Date;
  onChangeDate: (date: Date) => void;
  selectedDate?: Date;
  startDate?: Date;
  endDate?: Date;
  name: string;
  selectsStart?: boolean;
  selectsEnd?: boolean;
  onMonthChange?(date: Date): void;
  onFocus?(): void;
}

registerLocale('pt-BR', ptBr);

const DatePickerBase = ({
  name,
  label,
  excludeDates,
  hideTodayButton = false,
  includeDates,
  isClearable = true,
  isDisabled = false,
  maxDate,
  minDate,
  startDate,
  endDate,
  selectsEnd = false,
  selectsStart = false,
  onMonthChange,
  onFocus,
  placeholder,
  onChangeDate,
  selectedDate,
  ...rest
}: IDatePickerProps): JSX.Element => (
  <Box>
    {!!label && (
      <FormLabel htmlFor={name} data-disabled={isDisabled ? '' : undefined}>
        {label}
      </FormLabel>
    )}

    <ReactDatePicker
      name={name}
      dateFormat="dd/MM/yyyy"
      excludeDates={excludeDates}
      includeDates={includeDates}
      isClearable={isClearable}
      disabled={isDisabled}
      locale="pt-BR"
      maxDate={maxDate}
      minDate={minDate}
      startDate={startDate}
      endDate={endDate}
      onChange={onChangeDate}
      onFocus={onFocus}
      onMonthChange={onMonthChange}
      placeholderText={placeholder}
      selectsEnd={selectsEnd}
      selectsStart={selectsStart}
      selected={selectedDate}
      todayButton={!hideTodayButton ? 'Hoje' : undefined}
      customInput={
        <ChakraInput
          _disabled={{
            background: 'gray.100',
            borderColor: 'gray.300',
            color: '#99999a',
            opacity: 0.8,
            cursor: 'not-allowed',
          }}
          borderColor="gray.300"
          bg="gray.100"
          focusBorderColor="blue.300"
          onKeyUp={(e) => {
            e.currentTarget.maxLength = 10;

            e.currentTarget.value = e.currentTarget.value
              .replace(/\D/g, '')
              .replace(/(\d{2})(\d)/, '$1/$2')
              .replace(/(\d{2})(\d)/, '$1/$2');
          }}
          size="lg"
          variant="outline"
          {...rest}
        />
      }
    />
  </Box>
);

export default DatePickerBase;
